'use strict';

class EventEdit {
  constructor($scope, $location, $window, $routeParams, $filter, eventService, commonService, originatorService, productService, I18N, Notification) {
    this.$scope = $scope;
    this.$location = $location;
    this.$window = $window;
    this.$filter = $filter;
    this.eventService = eventService;
    this.commonService = commonService;
    this.originatorService = originatorService;
    this.productService = productService;
    this.I18N = I18N;
    this.Notification = Notification;

    this.number = parseInt($routeParams.number, 10);
  }

  $onInit() {
    const _this = this;

    this.event = {
      name: null,
      date: null,
      location: {
        name: null,
        address: null,
        zip: null,
        city: null,
        country: 'NORGE'
      },
      description: '',
      confirmMessage: null,
      confirmation: true,
      price: null,
      contactPerson: {
        name: null,
        email: null,
        phone: null
      },
      participantLimit: null,
      smsConfirmation: {
        enabled: false,
        message: null
      },
      emailConfirmation: {
        enabled: false,
        message: null
      },
      productNumber: null,
      registrationDeadline: null,
      endDate: null,
      taxRate: 0,
      customFields: [],
      signupCaptcha: false,
      autoDeleteParticipants: false,
      signupSmsNotification: false
    };

    this.eventDate = {};
    this.regDate = {};
    this.endDate = {};

    // tax rates
    this.taxRates = [];
    this.commonService.getConstants()
      .then((resp) => {
        this.taxRates = resp.taxRates;
      });

    // country list
    this.countries = ['NORGE'];
    this.commonService.getCountries()
      .then((resp) => {
        this.countries = resp;
      });

    // get product
    this.$scope.$on('productNo', (e, data) => {
      this.event.productNumber = data;
    });

    // datepicker
    this.commonService.datePicker({
      field: $('#date')[0],
      onSelect: this.copyDate()
    });

    this.commonService.datePicker({
      field: $('#registrationDeadline')[0],
      onSelect: this.copyDate()
    });

    this.commonService.datePicker({
      field: $('#endDate')[0],
      onSelect: this.copyDate()
    });

    this.$scope.$watch('$ctrl.edit.event.smsConfirmation.enabled', () => {
      if (this.event.smsConfirmation.message === '' || this.event.smsConfirmation.message === null) {
        this.event.smsConfirmation.message = 'Din påmelding er mottatt. Du vil få en ny melding når påmeldingen bekreftes.';
      } else {
        this.event.smsConfirmation.message = this.event.smsConfirmation.message;
      }
    });

    this.$scope.$watch('$ctrl.edit.event.emailConfirmation.enabled', () => {
      if (this.event.emailConfirmation.message === '' || this.event.emailConfirmation.message === null) {
        this.event.emailConfirmation.message = 'Din påmelding er mottatt. Du vil få en ny melding når påmeldingen bekreftes.';
      } else {
        this.event.emailConfirmation.message = this.event.emailConfirmation.message;
      }
    });

    // Product lookup
    $('input[name="productNumber"]').autocomplete({
      minLength: 2,
      source: (req, resp) => {
        _this.productService.list(req.term, 25)
          .then((products) => {
            let suggestions = [];

            $.each(products.data.items, (i, val) => {
              let desc = val.description === null || val.description === '' ? '' : ' - ' + val.description;

              suggestions.push({
                value: val.code,
                label: val.code + desc
              });
            });

            resp(suggestions);
          });
      },
      select: (e, ui) => {
        if (ui.item !== null) {
          document.querySelector('input[name="productNumber"]').value = ui.item.productNo;
        }
      }
    });

    if (!isNaN(this.number)) {
      this.load();
    } else {
      this.loadStorage();
    }
  }

  undateify(date) {
    if (date && date !== null) {
      return {
        date: date ? moment(date, 'YYYY-MM-DD HH:mm').format('DD.MM.YY') : new Date(),
        hour: date ? moment(date, 'YYYY-MM-DD HH:mm').format('HH') : 0,
        minute: date ? moment(date, 'YYYY-MM-DD HH:mm').format('mm') : 0
      };
    } else {
      return {};
    }
  }

  dateify(date) {
    if (date && date.date && date.hour) {
      return moment(date.date + date.hour + date.minute, 'DD.MM.YYHHmm').format('YYYY-MM-DD HH:mm');
    }
  }

  loadInitialText() {
    this.originatorService.get()
      .then((resp) => {
        this.event.description = 'Behandling av personopplysninger:\n' +
          '\n' + resp.data.name +
          ' er behandlingsansvarlig for opplysningene du oppgir i forbindelse med din påmelding til dette arrangementet. Dine personopplysninger vil kun benyttes til å administrere din påmelding og deltakelse på arrangementet. Arrangøren vil kun dele dine personopplysninger med andre parter dersom det er nødvendig for å administrere din påmelding og deltakelse på arrangementet. Som eksempel nevnes www.SendRegning.no, som leverer påmeldingssystemet.' +
          ' Bruk av underleverandører vil kunne medføre en overføring av dine personopplysninger til et land utenfor EU/EØS, dette kan være land med et regelverk som ikke gir samme grad av beskyttelse av personopplysninger som reglene i Norge. Overføringen skjer i samsvar med den til enhver tid gjeldende personvernlovgivning.\n' +
          ' \n' +
          'Dine personopplysninger vil bli slettet når arrangementet er gjennomført. Dersom du har ytterligere spørsmål om hvordan dine opplysninger behandles, eller dersom du ønsker å gjøre gjeldende din rett til å be om innsyn i, eller begrensning av, behandlingen, korrigering eller sletting av personopplysninger, dataportabilitet eller til å protestere mot behandlingen, ta kontakt med ' + resp.data.contact.email + '.' +
          ' Dersom du mener dine opplysninger ikke behandles korrekt, har du rett til å sende inn en klage til Datatilsynet.';

        this.$window.sessionStorage.setItem('event', angular.toJson(this.event));
      });
  }

  loadStorage() {
    // load saved event if any
    if (this.$window.sessionStorage.getItem('event')) {
      this.event = angular.fromJson(this.$window.sessionStorage.getItem('event'));

      // reset dates if empty
      this.eventDate = this.undateify(this.event.date);
      this.regDate = this.undateify(this.event.registrationDeadline);
      this.endDate = this.undateify(this.event.endDate);
    } else {
      this.loadInitialText();
    }
  }

  load() {
    this.eventService.getEvent(this.number)
      .then((resp) => {
        this.event = resp.data;

        // dates
        this.event.date = moment(resp.data.date, 'YYYY-MM-DD HH:mm');
        this.event.endDate = moment(resp.data.endDate, 'YYYY-MM-DD HH:mm');

        if (resp.data.registrationDeadline !== null) {
          this.event.registrationDeadline = moment(resp.data.registrationDeadline, 'YYYY-MM-DD HH:mm');
        }

        // save first into storage then load it back
        this.$window.sessionStorage.setItem('event', angular.toJson(this.event));
        this.loadStorage();

        this.eventDate = this.undateify(resp.data.date);
        this.endDate = this.undateify(resp.data.endDate);
        this.regDate = this.undateify(resp.data.registrationDeadline);
      });
  }

  validate() {
    if (this.event.date && moment().diff(this.event.date) > 0) {
      this.Notification.error(this.I18N.event.error.pastRegistrationDate);
    } else if (this.event.registrationDeadline && moment(this.event.date).diff(this.event.registrationDeadline) < 0) {
      this.Notification.error(this.I18N.event.error.beforeDate);
    } else if (this.event.endDate && moment(this.event.date).diff(this.event.endDate) > 0) {
      this.Notification.error(this.I18N.event.error.pastEndDate);
    } else {
      return true;
    }
  }

  saveStorage() {
    this.$window.sessionStorage.setItem('event', angular.toJson(this.event));
  }

  emptyStorage() {
    this.$window.sessionStorage.removeItem('event');
  }

  updateFields(field, swal) {
    let index = this.event.customFields.indexOf(field);

    this.event.customFields.splice(index, 1);
    this.$window.sessionStorage.setItem('event', angular.toJson(this.event));

    this.loadStorage();
    swal.close();
  }

  removeCustomField(field) {
    swal({
      title: 'Er du sikker?',
      text: 'Hvis du fjerner dette feltet vil alle registrerte data fra tidligere påmeldinger bli slettet. Det vil ikke være mulig å gjenopprette disse dataene. Er du sikker på at du vil fjerne dette feltet?',
      showCancelButton: true,
      confirmButtonColor: '#970b0e',
      confirmButtonText: 'Ja',
      cancelButtonText: 'Nei',
      closeOnConfirm: false,
      showLoaderOnConfirm: true
    }, (answer) => {
      if (answer) {
        if (!isNaN(this.number)) {
          this.eventService.deleteCustomField(this.number, field.number)
            .then(() => this.updateFields(field, swal));
        } else {
          this.updateFields(field, swal);
        }
      }
    });
  }

  copyDate() {
    this.event.date = this.dateify(this.eventDate);
    this.event.endDate = this.dateify(this.endDate);
    this.event.registrationDeadline = this.dateify(this.regDate);
  }

  save() {
    this.copyDate();

    // make sure event price isn't a string
    this.event.price = this.$filter('defaultValue')(this.$filter('numberify')(this.event.price), null);

    // save product
    if (this.event.productNumber) {
      this.productService.save({
        number: null,
        code: this.event.productNumber,
        description: this.event.name,
        unitPrice: this.event.price,
        taxRate: this.event.taxRate,
        vendorNumber: null,
        accountNumber: null
      });
    }

    if (this.validate()) {
      if (!isNaN(this.number) && this.$location.hash() !== 'kopi') {
        this.eventService.updateEvent(this.event.number, this.event)
          .then(() => this.$location.path('/vert'));
      } else {
        this.eventService.saveEvent(this.event)
          .then(() => this.$location.path('/vert'));
      }

      this.emptyStorage();
    }
  }
}

EventEdit.$inject = ['$scope', '$location', '$window', '$routeParams', '$filter', 'eventService', 'commonService', 'originatorService', 'productService', 'I18N', 'Notification'];

const eventEdit = {
  controller: EventEdit,
  templateUrl: 'event/edit.html'
};

angular
  .module('SendRegning')
  .component('eventEdit', eventEdit)
  .config(($routeProvider) => {
    $routeProvider
      .when('/vert/:number', {
        title: 'Arrangement',
        template: '<event-edit />',
        secure: true
      });
  });
